import {
  createZoomService,
  createZoomHooks,
} from '@qler-view/shared_lib/src/shared/zoom';
import { httpRequest } from '../lib/utils/httpClient';

export const zoomService = createZoomService(httpRequest);
export const zoomHooks = createZoomHooks(zoomService);

export const {
  useInitiateMeeting,
  useUpdateZoomLog,
  useUpdateZoomTimestamps,
  useUpdateConsultStatus,
  useZoomSignature,
  useZoomMeetingDetails,
  useUpdateCustomCallStartEvents,
  useMeetingLinkInviterpreter,
  useStartZoomMeeting,
  ensureUrlProtocol,
  useGetZoomParticipantJoinedDetails,
} = zoomHooks;
